import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import Switch from 'flarum/common/components/Switch';
import sortTags from 'ext:flarum/tags/common/utils/sortTags';
const translationPrefix = 'migratetoflarum-fake-data.lib.generator.';
export default class GeneratorForm extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "bulk", false);
    _defineProperty(this, "userCount", 0);
    _defineProperty(this, "discussionCount", 0);
    _defineProperty(this, "discussionTag", 'none');
    _defineProperty(this, "postCount", 0);
    _defineProperty(this, "dateStart", '');
    _defineProperty(this, "dateInterval", '');
    _defineProperty(this, "dirty", false);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "output", null);
  }
  view() {
    const disabled = this.loading || this.output;
    return m('.Form', m('.Form-body', [m('.Form-group', [Switch.component({
      state: this.bulk,
      onchange: value => {
        this.bulk = value;
      },
      disabled
    }, app.translator.trans(translationPrefix + 'bulk-mode')), m('.helpText', app.translator.trans(translationPrefix + 'bulk-mode-description'))]), m('.Form-group', [m('label', app.translator.trans(translationPrefix + 'user-count')), m('input.FormControl', {
      type: 'number',
      min: '0',
      value: this.userCount + '',
      oninput: event => {
        this.userCount = parseInt(event.target.value);
        this.dirty = true;
      },
      disabled
    })]), this.attrs.discussion ? null : [m('.Form-group', [m('label', app.translator.trans(translationPrefix + 'discussion-count')), m('input.FormControl', {
      type: 'number',
      min: '0',
      value: this.discussionCount + '',
      oninput: event => {
        this.discussionCount = parseInt(event.target.value);
        this.dirty = true;
      },
      disabled
    })]), flarum.extensions['flarum-tags'] ? m('.Form-group', [m('label', app.translator.trans(translationPrefix + 'discussion-tags')), m('span.Select', [m('select.Select-input.FormControl', {
      onchange: event => {
        this.discussionTag = event.target.value;
      },
      value: this.discussionTag,
      disabled
    }, [m('option', {
      value: 'none'
    }, app.translator.trans(translationPrefix + 'discussion-tags-none')), m('option', {
      value: 'random'
    }, app.translator.trans(translationPrefix + 'discussion-tags-random')), sortTags(app.store.all('tags')).map(tag => {
      let label = tag.name();
      const ids = [tag.id()];
      if (tag.isChild()) {
        const parent = tag.parent();
        label = parent.name() + ' / ' + label;
        ids.push(parent.id());
      }

      // Sort IDs in the comma-separated value so we can compare two values and know it's the same
      const value = ids.sort().join(',');
      return m('option', {
        value
      }, label);
    })]), m(Icon, {
      name: 'fas fa-sort',
      className: 'Select-caret'
    })])]) : null], m('.Form-group', [m('label', app.translator.trans(translationPrefix + 'post-count')), m('input.FormControl', {
      type: 'number',
      min: '0',
      value: this.postCount + '',
      oninput: event => {
        this.postCount = parseInt(event.target.value);
        this.dirty = true;
      },
      disabled
    })]), m('.Form-group', [m('label', app.translator.trans(translationPrefix + 'date')), m('.FakeData-Date', [m('input.FormControl', {
      type: 'text',
      value: this.dateStart + '',
      oninput: event => {
        this.dateStart = event.target.value;
        this.dirty = true;
      },
      disabled,
      placeholder: app.translator.trans(translationPrefix + 'date-start-placeholder')
    }), m('input.FormControl', {
      type: 'text',
      value: this.dateInterval + '',
      oninput: event => {
        this.dateInterval = event.target.value;
        this.dirty = true;
      },
      disabled,
      placeholder: app.translator.trans(translationPrefix + 'date-interval-placeholder')
    })])]), m('.Form-group', [this.output === null ? Button.component({
      disabled: !this.dirty,
      loading: this.loading,
      className: 'Button Button--primary',
      onclick: () => {
        this.loading = true;
        const body = {
          bulk: this.bulk,
          user_count: this.userCount,
          post_count: this.postCount,
          date_start: this.dateStart,
          date_interval: this.dateInterval
        };
        if (this.attrs.discussion) {
          body.discussion_count = 0;
          body.discussion_ids = [this.attrs.discussion.id()];
        } else {
          body.discussion_count = this.discussionCount;
          if (this.discussionTag === 'random') {
            body.tag_ids = 'random';
          } else if (this.discussionTag !== 'none') {
            body.tag_ids = this.discussionTag.split(',');
          }
        }
        app.request({
          url: app.forum.attribute('apiUrl') + '/fake-data',
          method: 'POST',
          body
        }).then(response => {
          this.dirty = false;
          this.loading = false;
          this.output = response && response.output || '<no output>';
          m.redraw();
        }).catch(e => {
          this.loading = false;
          m.redraw();
          throw e;
        });
      }
    }, app.translator.trans(translationPrefix + 'send')) : [Button.component({
      className: 'Button',
      onclick: () => {
        this.userCount = 0;
        this.discussionCount = 0;
        this.discussionTag = 'none';
        this.postCount = 0;
        this.output = null;
      }
    }, app.translator.trans(translationPrefix + 'reset')), this.attrs.discussion ? [Button.component({
      className: 'Button Button--primary',
      onclick: () => {
        app.modal.close();
        window.location.reload();
      }
    }, app.translator.trans(translationPrefix + 'refresh'))] : null, m('pre', this.output)]])]));
  }
}
flarum.reg.add('migratetoflarum-fake-data', 'common/components/GeneratorForm', GeneratorForm);